import Modal from '~/javascripts/components/Modal';
import t from '~/javascripts/utils/translation';

const ConsentInfoModal = ({ modalId, country }) => {
  const innerText =
    country === 'uk'
      ? t('views.donate_form.email_mail_consent_info')
      : t('views.donate_form.email_mail_sms_consent_info');

  return (
    <Modal modalId={modalId} modalInnerClassName='consent-info-modal'>
      <p>{innerText}</p>
    </Modal>
  );
};

export default ConsentInfoModal;
